var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElyseosLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 764.71 766.49",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "translate(-6867.6 -6851.2)",
    d: "m6923.5 7324.8 29.5-41.52-54.24-54.77 55-55.54-30.27-43 320.77-253.17 320.37 252.8c-8.72 15.2-20 28.16-29.78 43.35l55 55.24-54.21 54.88 29.62 41.81-320.69 255.41q-160.7-127.86-321.07-255.49z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m7244.4 6895.1 95.55 133.56c-3.67 1.82-6.49 3.26-9.35 4.64q-108.67 52.62-127.94 171.82c-2 12.54-1.69 25.46-3.31 38.1-7.19 56-37.36 94.28-89.9 114.92a44.45 44.45 0 0 1-4.24 1.35c-0.85 0.24-1.73 0.33-3.56 0.66l-9.89-13.52c61.09-20 94.37-60 91.95-125-1-26.32-12.25-49.28-30.2-68.77s-40-31.32-67.1-36.54l10-14.64c21.18 4.61 39.41 14.45 55.9 27.91 16.3 13.31 27.69 30.54 37.51 49l2.09-0.22 6.24-19.82c-20.9-35.38-50.7-58.84-90.58-71.66 3.86-5.66 7.23-10.63 10.82-15.9 36.4 11.86 64.53 34 87.84 65.44l8.85-16.32c-22.41-29.32-50.87-49.78-85.93-63.55l9.46-13.41c34.32 12.17 61.48 33.12 85.86 60l10.21-13.27c-23.25-27.48-51.91-46.75-85.77-61.22 31.67-44.81 63.25-88.68 95.49-133.56z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m7392 7101.6 10 13.7c-61.3 16.27-97.16 53.92-98.3 118-0.76 42.37 25.87 95 93.17 112.92l-10.27 14.53c-41.61-12.2-70.19-38.41-88.87-76.4-4.45 5.34-5 6.75-8 20.84 19.17 33.64 48.07 56.43 86.25 70.09-3.91 5.6-7.32 10.48-10.84 15.5-17.68-5.49-32.53-14.53-46.6-25s-25.48-23.66-37.42-38.73l-8.62 16.18c21.64 28.28 48.9 48.42 82.09 62.22l-9.69 13.28c-32.52-12.29-58.56-32.75-82.58-59.1-1.39 2.27-2.25 3.8-3.22 5.25-2 2.92-4 5.79-6.16 9 22.7 26.22 50 45.11 81.83 59.45l-89.43 125.06c-5.69-4.25-82.43-110.2-91.59-126.32 3-1.59 6.05-3.22 9.12-4.76q72.53-36.27 105.42-110.39a214.44 214.44 0 0 0 18.32-82.07c1.07-39.86 15.42-73.94 44.68-101.48 16.04-15.16 39.87-27.86 60.71-31.77z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m7414 7132.3 68.35 94.74-73.76 103c-49.82-4.46-88.43-49.3-87.72-101 0.76-55 46.96-95.39 93.13-96.74z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m7079.9 7330-73.53-102.8 68.34-94.9c44.29 1.38 89.26 40.12 92 92.27 3.33 61.12-43.82 101.71-86.81 105.43z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m7276.9 7532.8c70.43-98.48 140.85-197 212-296.48 12.28 17.16 23.78 33.25 35 49-3.62 6.79-230.9 235.59-247 247.48z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "M6963.78,7286.83c10.82-15.17,21-29.41,31.16-43.62,1.2-1.68,2.61-3.19,3.77-4.59a8.66,8.66,0,0,1,1.24-.08,1.34,1.34,0,0,1,.79.27c1.72,2,3.54,4,5.08,6.14,69.19,96.75,138.37,193.52,205.38,287.26Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m7205.6 6930.8-204.59 285.78c-5.89-4.42-27.39-33.33-35.55-47.66l238.63-239z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m7488.8 7218-204.2-285.17 238.35 237.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m7369.9 7070.8 10.9 15.26c-7.35 3-14 5.39-20.36 8.43-54.3 26.11-84.52 69.19-90.26 129.19-1.75 18.31-2.12 36.77-7 54.69-17.41 64.49-56.35 110.72-117.32 138.24a26.21 26.21 0 0 1-3.22 0.87l-8.71-12.14c3.49-1.73 6.26-3.15 9.08-4.5 46.55-22.31 79.67-57.2 98.1-105.56 7.34-19.28 11.61-39.29 11.08-60.08-1.16-45.73 15.11-84.9 45.52-118.29 19.56-21.43 43.46-36.65 72.19-46.11z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m7350.6 7043.7 8.62 12.17c-2.76 1.36-5 2.58-7.31 3.58q-79.41 33.82-108 115.26a153.34 153.34 0 0 0-8.66 53.36c0.71 49.61-17.45 91.48-52.94 125.9a164.89 164.89 0 0 1-48.55 32.59c-3.19 1.4-6.56 2.4-10.48 3.82l-10.57-14.65c3.17-1.54 5.44-2.76 7.79-3.77 58.83-25.43 90.86-70.46 97.25-133.86 1.78-17.7 1.61-35.59 6.36-52.94 18.1-66.12 58.39-113 121.48-140a51.47 51.47 0 0 1 5.01-1.46z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m7550.7 7132c-8.21 11.43-15.62 21.73-22.52 31.32l-234.46-233.31 0.29-0.47z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "M6960.26,7163.39c-6.93-9.73-14.3-20.07-22.34-31.37l253.7-200.14.6.79Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m7527.8 7290.8c7.14 9.88 13.4 18.49 19.6 27.15 1 1.4 1.74 3 3 5.18l-252.56 201.12-1.22-1.37z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m6959.8 7292.4 232.14 230.89-0.78 1-253-201.27z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m7495.5 7227.2 35.43-49.43 50 50.16-49.65 49.12z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6867.6 -6851.2)",
    d: "m6993.1 7227.3c-12.46 17.46-24.3 34-37 51.78l-50.71-50.73 51.52-51.61z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "translate(-6867.6 -6851.2)",
    d: "m7178.7 7495.6c10.4 12.48 20.77 25 31.23 37.4a29.4 29.4 0 0 0 4.42 3.6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "translate(-6867.6 -6851.2)",
    d: "m7307 7499.2-30.3 35.65"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "translate(-6867.6 -6851.2)",
    d: "m7282.1 6928.8 33.91 40.11"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "translate(-6867.6 -6851.2)",
    d: "m7205.4 6928.8q-15.15 18.28-30.31 36.55"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "translate(-6867.6 -6851.2)",
    d: "m7292.8 6928.8c7.13 6.84 14.11 13.84 21.43 20.46 8.44 7.62 17.19 14.9 25.81 22.33"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "translate(-6867.6 -6851.2)",
    d: "m7193 6932.4-49 42.78"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "translate(-6867.6 -6851.2)",
    d: "m7348 7477.8-51.69 46.34"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "translate(-6867.6 -6851.2)",
    d: "m7143 7479.6 49.91 44.56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "translate(-6867.6 -6851.2)",
    d: "m7333.8 7433.2-6.24 1.79"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "translate(-6867.6 -6851.2)",
    d: "m7411.3 7132c-0.59 3.27-1.19 6.54-1.78 9.81"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElyseosLogo);
export default __webpack_public_path__ + "static/media/elyseos_logo.96b0ebe8.svg";
export { ForwardRef as ReactComponent };